import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import ValidatedFormGroup from "../../Default/common/validated-form-group.vue";
import ValidationMessage from "../../Default/common/validation-message.vue";
import StreetAutocomplete from "../../../../../Scripts/vue-components/bootstrap-components/street-autocomplete.vue";
import PostalAutocomplete from "../../../../../Scripts/vue-components/bootstrap-components/postal-autocomplete.vue";
import { ValidationErrors } from "../../new-contract-vue";
import { IContractViewModel, IFinalInvoicingAddressViewModel, IMeteringPointViewModel } from "../../../../../Scripts/inpulse/I4UViewModels";
import { SectionChecker } from "../../Default/common/section";

class Checker extends SectionChecker {
    constructor() {
        super();
    }
}
export const MoveOutCompanyChecker = new Checker();

@Component({
    components: {
        ValidatedFormGroup,
        ValidationMessage,
        PostalAutocomplete,
        StreetAutocomplete,
    },
})

export default class MoveOutCompanySelection extends Vue {
    get moveOutName(): string { return this.$store.state.moveOutUser; }
    get contractsSelected(): boolean { return this.$store.state.contract.MoveOutProcess.ConsumptionPoints.length > 0; }
    get contract(): IContractViewModel { return this.$store.state.contract; }
    get meteringPoint(): IMeteringPointViewModel { return this.$store.state.contract.MeteringPoint; }
    get finalInvoicingAddress(): IFinalInvoicingAddressViewModel { return this.$store.state.contract.MoveOutProcess.FinalInvoicingAddress; }

    get mpStreet(): string { return this.finalInvoicingAddress.Address.Street }
    get postal(): string { return this.finalInvoicingAddress.Address.Zip }
    get postOffice(): string { return this.finalInvoicingAddress.Address.Place }
    get coName(): string { return this.finalInvoicingAddress.Address.COName }

    changeValue(payload: { key: string, value: string }) { return this.$store.dispatch("changeValue", payload); }

    @Prop()
    public validationErrors: ValidationErrors;

    postalStr: string;
    mpStreetStr: string;
    mpStreetLocale: string = null;
    mpZipLocale: string = null;

    constructor() {
        super();
        console.log("MoveOutCompanySelection constructor");
        this.mpStreetStr = this.mpStreet;
        console.log("mpStreetStr: " + this.mpStreetStr);
        this.postalStr = this.postal;
        this.FirstNameContactperson1 = this.$store.state.contract.Company.ContactPersons.length > 0 ? this.$store.state.contract.Company.ContactPersons[0].FirstName : "";
        this.LastNameContactperson1 = this.$store.state.contract.Company.ContactPersons.length > 0 ? this.$store.state.contract.Company.ContactPersons[0].LastName : "";
        this.PhoneNumberContactperson1 = this.$store.state.contract.Company.ContactPersons.length > 0 ? this.$store.state.contract.Company.ContactPersons[0].Phone : "";
        this.EmailContactperson1 = this.$store.state.contract.Company.ContactPersons.length > 0 ? this.$store.state.contract.Company.ContactPersons[0].Email : "";
    }

    @Watch("mpStreet")
    keepMpSync() {
        this.mpStreetStr = this.mpStreet;
        console.log("Watch / mpStreet: " + this.mpStreet);
    }

    @Watch("postal")
    keepSync() {
        this.postalStr = this.postal;
    }

    FirstNameContactperson1: string = null;
    FirstNameContactperson1Changed(): void {
        this.changeValue({ key: "FirstName__contactperson-1", value: this.FirstNameContactperson1 });
    }

    LastNameContactperson1: string = null;
    LastNameContactperson1Changed(): void {
        this.changeValue({ key: "LastName__contactperson-1", value: this.LastNameContactperson1 });
    }

    PhoneNumberContactperson1: string = null;
    PhoneNumberContactperson1Changed(): void {
        this.changeValue({ key: "Phone__contactperson-1", value: this.PhoneNumberContactperson1 });
    }

    EmailContactperson1: string = null;
    EmailContactperson1Changed(): void {
        this.changeValue({ key: "Email__contactperson-1", value: this.EmailContactperson1 });
    }

    meteringPointPostalSelected(postCode: string, locale: string) {
        this.postalStr = postCode;
        this.mpZipLocale = locale;
        this.$store.dispatch("changeValue", { key: "MoveOutZipOnline", value: postCode, locale: locale });
    }

    meteringPointStreetSelected(street: string, locale: string) {
        this.mpStreetStr = street;
        this.mpStreetLocale = locale;
        console.log("meteringPointStreetSelected / street: " + street);
        this.$store.dispatch("changeValue", { key: "MoveOutStreetOnline", value: street, locale: locale });
    }

}